import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AlertService {

  constructor(private toastr: ToastrService) {
  }

  error(message: string): void {
    this.toastr.error(message, 'Error');
  }

  success(message: string): void {
    this.toastr.success(message, 'Success');
  }

  info(message: string): void {
    this.toastr.info(message, 'Info');
  }

  warn(message: string): void {
    this.toastr.warning(message, 'Warning');
  }
}
